import { render, staticRenderFns } from "./OrderMgmt.vue?vue&type=template&id=3fe3b7ec"
import script from "./OrderMgmt.vue?vue&type=script&lang=js"
export * from "./OrderMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports